export const UNAVAILABLE_IMAGE_URL = 'https://assets.thdstatic.com/images/v1/no-img.svg';

export const ORDER_DETAILS_URL = '/myaccount/order-details';

export const CUSTOMER_TYPES = {
  B2B: 'b2b',
  B2C: 'b2c'
};

export const REQUEST_TIMEOUT = 30000;
